<template>
    <div v-if="limitFiles" class="col-12 px-5">
        <div class="alert alert-danger">Por favor añada un solo archivo</div>
    </div>
    <div class="dropClients">
        <div class="dropClients-dropzone-container" @dragover="dragover" @dragleave="dragleave" @drop="drop">
            <input type="file" multiple name="file" id="fileInput" class="dropClients-dropzone-container-hidden-input" @change="onChange" ref="file"
                accept=".csv,.xlsx" />

            <label for="fileInput" class="dropClients-dropzone-container-file-label">
                <div v-if="isDragging">Suelta para insertar archivo</div>
                <div v-else>Arrastrese el archivo aqui o <u>haz click aqui</u> para añadir.</div>
            </label>
            <div class="d-flex justify-content-center dropClients-dropzone-container-preview-container mt-4" v-if="files.length">
                <div v-for="file in files" :key="file.name" class="dropClients-dropzone-container-preview-container-preview-card">
                    <div class="position-relative">
                        <button type="button" class="close" @click="remove()" aria-label="Delete">
                            <span aria-hidden="true">&times;</span>
                        </button>
                        <v-icon name="bi-filetype-csv" scale="3.5" />
                        <p class="fileName">
                            {{ file.name }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <small class="form-text text-danger ml-4" v-if="errorMessageMaxLength">Máximo 1 archivo</small>
    <ModalError :id="'modalError'" :modalTitle="'SE HA PRODUCIDO UN ERROR'" :class="'modal'" :showFooter="false"
    :message="errorMessage" :code="errorCode" />
</template>

<script>
import axios from 'axios';
import { Modal as ModalBootstrap } from "bootstrap";
import ModalError from '../../../Shared/ModalError.vue';
export default {
    data() {
        return {
            isDragging: false,
            files: [],
            limitFiles: false,
            base64File: "",
            maxLength: 1,
            errorMessageMaxLength: false
        };
    },
    components: {
        ModalError
    },
    methods: {
        onChange() {
            this.files = [...this.$refs.file.files];
            if (this.files.length > this.maxLength) {
                this.errorMessageMaxLength= true;
                this.files = []
            }else{
                this.errorMessageMaxLength= false;
                this.handleFileSelect(this.files[0]);
            }
        },
        clientList(result){
            this.$emit("clientList", result);
        },
        handleFileSelect(evt) {
            var vm = this;
            var f = evt; // FileList object
            var reader = new FileReader();
            // Closure to capture the file information.
            reader.onload = (function() {
                return function(e) {
                var binaryData = e.target.result;
                //Converting Binary Data to base 64
                var bodyToSend = {
                    csv: window.btoa(binaryData)
                }
                axios.post('/promotions/validate/custumer-csv', bodyToSend)
                    .then((response) => {
                        vm.clientList(response.data.split(","));
                    })
                    .catch((error) => {
                        console.log(error);
                        this.errorCode = error.response.data.code
                        this.errorMessage = error.response.data.message
                        var myModal = new ModalBootstrap(document.getElementById('modalError'))
                        myModal.show()
                        vm.clientList([]);
                    });
                };
            })(f);
            // Read in the image file as a data URL.
            reader.readAsBinaryString(f);
        },
        dragover(e) {
            e.preventDefault();
            this.isDragging = true;
        },
        dragleave() {
            this.isDragging = false;
        },
        drop(e) {
            e.preventDefault();
            if (e.dataTransfer.files.length < 2) {
                this.$refs.file.files = e.dataTransfer.files;
                this.onChange();
                this.limitFiles = false
            } else {
                this.limitFiles = true;
            }
            this.isDragging = false;
        },
        remove() {
            this.files = [];
            this.$refs.file.value = '';
            this.clientList([]);
        },
        uploadFiles() {
            const files = this.files;
            const formData = new FormData();
            files.forEach((file) => {
                formData.append("file", file);
            });
            formData.append('backOfficeUser', this.$cookies.get('username'));
            formData.append('requester', this.$cookies.get('username'));
            formData.append('uploadDate', new Date().toISOString().split('T')[0]);
        },
    },
};
</script>
<style lang="scss">
.dropClients {
    display: flex;
    flex-grow: 1;
    align-items: center;
    min-height: 20px;
    &-dropzone-container {
        padding: 4rem;
        width: 45rem;
        max-height: 220px;
        background: #f7fafc;
        border: 1px solid #e2e8f0;
        &-hidden-input {
            display: none;
        }
        &-file-label {
            font-size: 20px;
            display: block;
            cursor: pointer;
        }
        &-preview-container {
            display: flex;
            margin-top: 2rem;
            &-preview-card {
                display: flex;
                padding: 5px;
                margin-left: 5px;
                .close {
                    font-size: 2.5rem;
                    line-height: 0.4;
                    font-weight: normal;
                    position: absolute;
                    top: 0;
                    right: -12px;
                }

                .fileName {
                    max-width: 100px;
                    max-height: 45px;
                    text-overflow: ellipsis;
                    overflow: hidden;
                }
            }
            

        }
    }
}
</style>